jQuery(document).on('ready', function () {

	"use strict";

	$(document).on('googleMapsAPIReady', function () {
		$('.contact-office__map').each(function () {
			var coordinates = new google.maps.LatLng($(this).data('latitude'), $(this).data('longitude'));

			var map = new google.maps.Map(this, {
				zoom: 15,
				center: coordinates
			});

			google.maps.event.trigger(map, 'resize');

			var marker = new google.maps.Marker({
				position: coordinates,
				map: map,
				icon: window.appConfig.websiteBaseUrlWithoutLanguage + '/app/themes/sportball-v3/assets/img/map-pin.png'
			});
		});
	});

});
